export default __webpack_public_path__ + "static/media/step_C@2x.20243106.png";